module.exports = __webpack_public_path__ + "static/media/Jared_Giangrasso_Resume.f663ff5f.pdf";